import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// Customer Pages
import { LoginPage } from './pages/customer/LoginPage';
import { RegisterPage } from './pages/customer/RegisterPage';
import { DashboardPage } from './pages/customer/DashboardPage';
import { PoliciesPage } from './pages/customer/PoliciesPage';
import { PolicyDetailsPage } from './pages/customer/PolicyDetailsPage';
import { InsuranceBuyPage } from './pages/customer/InsuranceBuyPage';
import { InsuranceTypeSelectorPage } from './pages/customer/InsuranceTypeSelectorPage';
import { ComparisonPage } from './pages/customer/ComparisonPage';
import { CheckoutPage } from './pages/customer/CheckoutPage';
import { ClaimsPage } from './pages/customer/ClaimsPage';
import { NewClaimPage } from './pages/customer/NewClaimPage';
import { ProfilePage } from './pages/customer/ProfilePage';
// Admin Pages
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { UsersPage } from './pages/admin/UsersPage';
import { ClaimsQueuePage } from './pages/admin/ClaimsQueuePage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        {/* Public Routes */}
        <Route path="/" element={<LoginPage data-id="element-3" />} data-id="element-2" />
        <Route path="/register" element={<RegisterPage data-id="element-5" />} data-id="element-4" />

        {/* Customer Routes */}
        <Route path="/dashboard" element={<DashboardPage data-id="element-7" />} data-id="element-6" />
        <Route path="/profile" element={<ProfilePage data-id="element-9" />} data-id="element-8" />

        <Route path="/policies" element={<PoliciesPage data-id="element-11" />} data-id="element-10" />
        <Route path="/policies/:id" element={<PolicyDetailsPage data-id="element-13" />} data-id="element-12" />

        <Route path="/insurance/select" element={<InsuranceTypeSelectorPage data-id="element-15" />} data-id="element-14" />
        <Route path="/insurance/buy" element={<InsuranceBuyPage data-id="element-17" />} data-id="element-16" />
        <Route path="/insurance/compare" element={<ComparisonPage data-id="element-19" />} data-id="element-18" />
        <Route path="/checkout" element={<CheckoutPage data-id="element-21" />} data-id="element-20" />

        <Route path="/claims" element={<ClaimsPage data-id="element-23" />} data-id="element-22" />
        <Route path="/claims/new" element={<NewClaimPage data-id="element-25" />} data-id="element-24" />

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminDashboard data-id="element-27" />} data-id="element-26" />
        <Route path="/admin/users" element={<UsersPage data-id="element-29" />} data-id="element-28" />
        <Route path="/admin/claims" element={<ClaimsQueuePage data-id="element-31" />} data-id="element-30" />
        <Route path="/admin/policies" element={<Navigate to="/admin" replace data-id="element-33" />} data-id="element-32" />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace data-id="element-35" />} data-id="element-34" />
      </Routes>
    </Router>;
}